<template>
    <div class="Binding">
        <a-modal :title="getTitle()" :visible="temporaryValue" @ok="handOk()" @cancel="temporaryValue = false" :width="1000">
            <div class="box">
                <div class="title">{{ getTitle() }}：</div>
                <div class="value">
                    <div>
                        <a-input-search placeholder="请输入电话号码搜索" @search="getCompany" />
                        <a-radio-group v-model="selectItem" @change="onChange" class="radio-box" v-if="type == 1 || type == 3">
                            <!-- <div class="header">
                                <div style="width:170px">统一社会信用代码</div>
                                <div style="width:220px">企业/机构全称</div>
                                <div style="width:100px">负责人</div>
                                <div style="width:100px">手机号</div>
                                <div style="width:200px">实验室名称</div>
                            </div>
                            <a-radio class="radioStyle" :value="item" v-for="(item, i) in userCompany_list" :key="i">
                                <span class="radio-item">
                                    <div style="width:170px">{{ item.unifiedSocialCreditCode }}</div>
                                    <div style="width:220px">{{ item.companyFullName }}</div>
                                    <div style="width:100px">{{ item.name }}</div>
                                    <div style="width:100px">{{ shield(item.phone, 'mobile') }}</div>
                                    <div style="width:200px">{{ item.laboratoryName }}</div>
                                </span>
                            </a-radio> -->
                            <div class="header">
                                <div style="width: 80px;margin-right:10px">负责人</div>
                                <div style="width: 90px;margin-right:10px">手机号</div>
                                <div style="width: 200px;margin-right:10px">实验室名称</div>
                                <div style="width: 100px;margin-right:10px">课题组老师姓名</div>
                                <div style="width: 163px">所在学院/部门</div>
                            </div>

                            <div class="list-box">
                                <a-radio class="radioStyle" :value="item" v-for="(item, i) in userCompany_list" :key="i">
                                    <div class="radio-item">
                                        <!-- <textBeyond :text="item.name" :width="80" /> -->
                                        <div style="width: 80px;margin-right:10px">{{ item.name }}</div>
                                        <div style="width: 90px;margin-right:10px">{{ shield(item.phone, 'phone') }}</div>
                                        <div style="width: 200px;margin-right:10px">{{ item.laboratoryName }}</div>
                                        <div style="width: 100px;margin-right:10px">{{ item.teacherName }}</div>
                                        <div style="width: 163px">{{ item.collegeDepartment }}</div>
                                    </div>
                                </a-radio>
                            </div>
                        </a-radio-group>
                        <div class="radio-box" v-else>
                            <div class="header">
                                <div style="width: 80px;margin-right:10px">负责人</div>
                                <div style="width: 90px;margin-right:10px">手机号</div>
                                <div style="width: 200px;margin-right:10px">实验室名称</div>
                                <div style="width: 100px;margin-right:10px">课题组老师姓名</div>
                                <div style="width: 163px">所在学院/部门</div>
                            </div>
                            <adiv class="radioStyle" :value="item" v-for="(item, i) in userCompany_list" :key="i">
                                <span class="radio-item">
                                    <div style="width: 80px;margin-right:10px;margin-left: 24px;">{{ item.name }}</div>
                                    <div style="width: 90px;margin-right:10px">{{ shield(item.phone, 'phone') }}</div>
                                    <div style="width: 200px;margin-right:10px">{{ item.laboratoryName }}</div>
                                    <div style="width: 100px;margin-right:10px">{{ item.teacherName }}</div>
                                    <div style="width: 163px">{{ item.collegeDepartment }}</div>
                                    <div class="unbinding" @click="unbinding(item)">解绑</div>
                                </span>
                            </adiv>
                        </div>
                        <div class="form2-box" v-if="type == 1 || type == 3">
                            <!-- <div>
                                <div class="title2 title">请完善真实姓名：</div>
                                <div class="value2 value">
                                    <a-input placeholder="请输入" v-model="data.userName" />
                                </div>
                            </div> -->
                            <div>
                                <div class="title2 title"><span style="color:#F24145">*</span>{{ type == 1 ? '主账号手机号：' : '子账号手机号：' }}</div>
                                <div class="value2 value">
                                    <a-input placeholder="请输入" v-model="data.phone" />
                                    <div style="width: 600px;font-size: 12px;color: #F24145;">
                                        {{ type == 1 ? '【注】请联系负责人获取验证码并输入，绑定成功后成为其子账号，共享权限和授信额度。' : '【注】请联系负责人获取验证码并输入，绑定成功后，该子账号共享主账号的权限和授信额度。' }}
                                    </div>
                                </div>
                                <div class="button getCode" @click="getCode()" v-if="isGetCode">获取验证码</div>
                                <div class="button getCode2" @click="getCode()" v-else>{{ getCode_text }}</div>
                            </div>
                            <div>
                                <div class="title2 title"><span style="color:#F24145">*</span>请输入验证码：</div>
                                <div class="value2 value">
                                    <a-input placeholder="请输入" v-model="data.code" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
    props: ['value', 'type', 'usCode'], //接收父组件的传值
    data() {
        return {
            data: {
                code: '',
                phone: '',
                type: 1
            },
            temporaryValue: null, //组件使用的变量
            userCompany_list: [],
            selectItem: [],
            getCode_text: '获取验证码',
            timer: null,
            isFinish: false,
            count: 3,
            unifiedSocialCreditCode: ''
        };
    },
    watch: {
        //监听父组件传值,并且监听初始化
        value: {
            handler: function(val) {
                console.log(val);
                this.temporaryValue = val; //将父组件的传值赋给绑定的值
                if (val) {
                    this.init();
                }
            },
            immediate: true
        },
        // 监听子组件的值改变,并且返回给父组件
        temporaryValue(val) {
            this.$emit('input', val); //将绑定的值反给父组件
        }
    },
    mounted() {},
    computed: {
        isGetCode() {
            return this.data.phone != this.selectItem.phone;
        }
    },
    methods: {
        init() {
            this.getCompany();
        },
        getTitle() {
            if (this.type == 1) {
                return '绑定主账号';
            } else if (this.type == 3) {
                return '绑定子账号';
            } else if (this.type == 2) {
                return '解绑子账号';
            }
        },
        unbinding({ uuid }) {
            this.api.unbind({ uuid }).then(res => {
                if (res.ok) {
                    this.$message.info(res.message);
                    this.init();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        //获取验证码接口
        getCode() {
            if (this.isGetCode) {
                this.$message.error('主账号手机号不一致!');
            } else {
                if (this.getCode_text == '获取验证码') {
                    let number = 119;
                    this.getCode_text = '120s';
                    this.timer = setInterval(() => {
                        if (number > 0) {
                            this.getCode_text = number + 's';
                            number--;
                        } else {
                            this.getCode_text = '获取验证码';
                            clearInterval(this.timer);
                        }
                        console.log(number);
                    }, 1000);

                    this.api
                        .sendCode({
                            type: this.type == 3 ? 2 : 1,
                            phone: this.data.phone
                        })
                        .then(result => {
                            if (result.ok) {
                                this.$message.info(result.message);
                            } else {
                                this.$message.err(result.message);
                            }
                        })
                        .catch(err => {});
                } else {
                    this.$message.warning('请勿频繁发送短息');
                }
            }
        },
        /**获取统一信用代码是否存在 */
        getCompany(search = '') {
            // console.log(this.data.unifiedSocialCreditCode, 'ddddd');
            this.api.getAccountList(`?type=${this.type}&usCode=${this.usCode}&search=${search}`).then(res => {
                this.userCompany_list = res.data;
                if (res.data.length == 0) {
                    this.$message.error('并未查询到相关账号');
                }
            });
        },
        //屏蔽名称/手机号
        shield(src, type) {
            if (type == 'phone') {
                let a = src.split('');
                a.splice(3, 4, '****');
                return a.join('');
            } else if (type == 'name') {
                let a = src.split('');
                let length = a.length - 1;
                let shieldList = [];
                for (let i = 0; i < length; i++) {
                    shieldList.push('*');
                }
                a.splice(1, length, ...shieldList);
                return a.join('');
            }
        },
        //点击确认
        handOk() {
            if (this.type == 1) {
                this.data.type = 1;
                this.api.verificationCode(this.data).then(result => {
                    if (result.ok) {
                        this.temporaryValue = false;
                        this.$message.info(result.message);
                    } else {
                        this.$message.error(result.message);
                    }
                });
            } else if (this.type == 3) {
                this.data.type = 2;
                this.api.verificationCode(this.data).then(result => {
                    if (result.ok) {
                        this.temporaryValue = false;
                        this.$message.info(result.message);
                    } else {
                        this.$message.error(result.message);
                    }
                });
            } else {
                this.temporaryValue = false;
            }
            this.$emit('refresh');
        }
    }
};
</script>

<style scoped>
.box {
    width: 1000px !important;
    /* height: 422px; */
    display: flex;
}
.title {
    width: 92px;
    height: 32px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    text-align: left;
}
.value {
    width: 400px;
    min-height: 32px;
    line-height: 32px;
    position: relative;
}
.icon {
    position: absolute;
    right: -30px;
    top: 0px;
}
.icon > img {
    width: 14px;
    height: 14px;
}
.button-box {
    width: 180px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.button-box > .next {
    width: 120px;
    height: 40px;
    background: #bfbfbf;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
}
.button-box > .next-pass {
    width: 120px;
    height: 40px;
    background: #2b9a34;
    text-align: center;
    line-height: 40px;
    color: #ffffff;
}
.form2-box > div {
    display: flex;
    margin-bottom: 18px;
}
.getCode {
    width: 80px;
    height: 32px;
    background: #bfbfbf;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    margin-left: 10px;
}
.getCode2 {
    width: 80px;
    height: 32px;
    background: #2b9a34;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
    margin-left: 10px;
}
.button-box > .cancel {
    color: #2b9a34;
    font-size: 14px;
}
.Bubble-card {
    /* width: 268px;
    height: 158px; */
    width: 280px;
    height: 170px;
    background-image: url('../assets/tips@2x.png');
    background-size: 100%;

    padding: 24px 26px 26px 34px;
    position: absolute;
    right: -278px;
    top: -63px;
}
.Bubble-card > .text {
    width: 220px;
    height: 72px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 24px;
    margin-bottom: 20px;
}
.Bubble-button {
    display: flex;
    justify-content: center;
}
.Bubble-button > .button {
    width: 60px;
    height: 28px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #ffffff;
    line-height: 28px;
    text-align: center;
}
.yes {
    background: #2b9a34;
}
.no {
    background: #bfbfbf;
    margin-right: 20px;
}
.radioStyle {
    display: flex;
    align-items: center;
    /* height: 30px; */
    line-height: 30px;
}
.radio-item {
    display: flex;
    width: 717px;
}
.radio-box {
    width: 717px;
    padding: 8px 10px;
    padding-bottom: 0;
    margin-top: 10px;
    border: 1px solid #ede9e9;
    margin-bottom: 14px;
    position: relative;
}
.title2 {
    width: 120px;
}
.value2 {
    width: 190px;
}
.header {
    width: 717px;
    height: 32px;
    background: #f2f2f2;
    border: 1px solid #ede9e9;
    display: flex;
    margin-top: -8px;
    margin-left: -10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    padding-left: 34px;
}
.unbinding {
    position: absolute;

    width: 28px;
    height: 30px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2b9a34;
    line-height: 30px;
    right: -38px;
}
.ant-input:hover {
    border-color: #2b9a34 !important;
}
.list-box {
    width: 706px;
    max-height: 141px;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 10px;
}
.radio-item > div {
    white-space: normal;
    line-height: 22px;
    height: 100%;
    margin: auto 0;
}
div {
    cursor: default;
}
</style>



// WEBPACK FOOTER //
// src/public/binding.vue